import { ControlListProps, useTranslations } from "@bsm/component";
import _ from "lodash";

export const useSchoolHolidayCreateForm = (id?: number): ControlListProps => {
    const [
        TITLE_CREATE,
        TITLE_EDIT,
        HOLIDAY_NAME,
        START_DATE,
        END_DATE,
        COMMENT,
        SAVE,
        CANCEL,
    ] = useTranslations(i18n);

    return {
        data: {
            title: id ? TITLE_EDIT : TITLE_CREATE,
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: "text",
                    name: "value",
                    label: HOLIDAY_NAME,
                    required: true,
                },
                {
                    type: "date",
                    name: "startDate",
                    label: START_DATE,
                    required: true,
                },
                {
                    type: "date",
                    name: "endDate", 
                    label: END_DATE,
                    required: true,
                },
                {
                    type: "textarea",
                    name: "comment",
                    label: COMMENT,
                },
                {
                    type: "hidden",
                    name: "holidayType",
                    defaultValue: "SCHOOL_HOLIDAY",
                },
                {
                    type: "hidden",
                    name: "year",
                    defaultValue: new Date().getFullYear().toString(),
                },
            ],
            hideBack: true,
            next: {
                label: SAVE,
                endIcon: "fas fa-save",
            },
            back: {
                label: CANCEL,
                startIcon: "fas fa-times",
            },
            graphQL: {
                entity: "holiday",
                entityId: id,
            },
        },
        onBeforeSaving: (value) => {
            if(!id) {
                const value_ = _.clone(value);
                value_.holidayType = 'SCHOOL_HOLIDAY';
                value_.year = new Date().getFullYear().toString();
                if(value_.startDate !== !value_.endDate) {
                    value_.isMultiDay = true;
                }
                return value_;
            }
            return value
        }
    };
};

const i18n = [
    "BSMRH.Holiday.Create.Title",
    "BSMRH.Holiday.Edit.Title",
    "BSMRH.Holiday.Form.Name.Label",
    "BSMRH.Holiday.Form.StartDate.Label",
    "BSMRH.Holiday.Form.EndDate.Label",
    "std_comment",
    "std_save",
    "std_cancel",
];